export const tableHeaderProps = {
  computed: {
    tableHeaderProps() {
      return {
        sortByText: this.$t('helpers.sortBy'),
      };
    },
  },
};
